"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.idempotentBabelPolyfill = idempotentBabelPolyfill;
exports.default = void 0;

function idempotentBabelPolyfill() {
  if (!global._babelPolyfill && ( // eslint-disable-next-line no-undef
  typeof window === 'undefined' || !window._babelPolyfill)) {
    return require('@babel/polyfill');
  }

  return null;
}

var _default = idempotentBabelPolyfill();

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/idempotent-babel-polyfill/lib/index.js
// module id = 1
// module chunks = 1